import { jsx as _jsx } from "react/jsx-runtime";
import { OrderRequestTemplates } from './OrderRequestTemplates/index.js';
import { OrderRequestMessageComposer } from './OrderRequestMessageComposer/index.js';
import { OrderRequestHistory } from './OrderRequestHistory/index.js';
import { workspaceKey_AdvisorSandboxEpic } from '../../workspace-configs.js';
import { TS_HorizontalWorkspace } from '@nu-art/ts-workspace-frontend/index';
import { Page_BaseSandbox } from '../Page_BaseSandbox/Page_BaseSandbox.js';
import { ModuleFE_ActiveUser } from '../../../_entity/advisor-session/ModuleFE_ActiveUser.js';
const EditorKey_SandboxOrderEpic = 'sandbox-order-epic';
export class Page_SandboxOrder extends Page_BaseSandbox {
    static Route = {
        key: 'order',
        path: 'order',
        Component: this,
    };
    workspace = () => ({
        id: EditorKey_SandboxOrderEpic,
        key: workspaceKey_AdvisorSandboxEpic,
        instances: {},
        renderers: {
            horizontalSpace: TS_HorizontalWorkspace,
            templates: () => _jsx(OrderRequestTemplates, {}),
            composer: () => _jsx(OrderRequestMessageComposer, {}),
            history: () => _jsx(OrderRequestHistory, {}),
        }
    });
    getHeader() {
        return 'Orders';
    }
    componentDidMount() {
        ModuleFE_ActiveUser.sandbox.onOpen();
    }
    componentWillUnmount() {
        ModuleFE_ActiveUser.sandbox.onClose();
    }
}
//# sourceMappingURL=Page_SandboxOrder.js.map